/* Bespoke CSS reserved for what Astryx components can't express: the
   hover/focus scope for the delete reveal, and a per-child flex property
   (the badge doesn't grow/shrink like its HStack siblings). All spacing
   inside the card is HStack/VStack gap; the number itself renders via
   Astryx's Badge, not hand-rolled text. */

.card {
  /* Establishes the hover/focus scope for the delete control below —
     hovering anywhere in the card's padded area reveals it. */
  position: relative;
}

.indexBadge {
  flex-shrink: 0;
  margin-top: var(--spacing-1);
}

.body {
  flex: 1;
  min-width: 0;
}

.delete {
  flex-shrink: 0;
  opacity: 0;
  transition: opacity var(--duration-fast) var(--easing-default);
}

.card:hover .delete,
.card:focus-within .delete {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .delete {
    transition: none;
  }
}

/* Entrance animation for a just-inserted card (see `isEntering` on
   QuestionCardProps). `.enterWrapper` is a thin, always-present wrapper
   around the Card so the grid-row trick below can animate an *unknown*,
   dynamic content height (a plain height/max-height animation would need a
   guessed cap) — animating `grid-template-rows` from `0fr` to `1fr` grows
   the row to the content's natural height regardless of what that is.
   `overflow: hidden` on the grid item (the Card itself) is required for the
   collapsed 0fr state to actually clip its content rather than just
   overflow the shrunken row. No highlight ring — grow + fade + slight
   translateY only. */
.enterWrapper {
  display: grid;
  grid-template-rows: 0fr;
  animation: questionCardGrowIn 220ms ease-out forwards;
}

.enterWrapper > .card {
  overflow: hidden;
}

@keyframes questionCardGrowIn {
  from {
    grid-template-rows: 0fr;
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    grid-template-rows: 1fr;
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .enterWrapper {
    animation: none;
    grid-template-rows: 1fr;
  }

  .enterWrapper > .card {
    overflow: visible;
  }
}
